(function () {
  var car = document.getElementById('beneCarousel'), track = document.getElementById('beneTrack');
  if (!car || !track) return;
  Array.prototype.slice.call(track.children).forEach(function (n) { track.appendChild(n.cloneNode(true)); });
  var x = 0, speed = 0.35, dragging = false, startX = 0, startPos = 0, last = 0, setW = 0, moved = 0;
  function measure() { setW = track.scrollWidth / 2; }
  measure(); window.addEventListener('resize', measure); window.addEventListener('load', measure);
  function norm() { if (setW > 0) { while (x <= -setW) x += setW; while (x > 0) x -= setW; } }
  function frame(t) {
    if (!last) last = t; var dt = t - last; last = t;
    if (!dragging) { x -= speed * dt / 16.7; }
    norm(); track.style.transform = 'translate3d(' + x + 'px,0,0)';
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);
  car.addEventListener('pointerdown', function (e) { dragging = true; moved = 0; startX = e.clientX; startPos = x; car.classList.add('grabbing'); try { car.setPointerCapture(e.pointerId); } catch (_) {} });
  car.addEventListener('pointermove', function (e) { if (!dragging) return; var d = e.clientX - startX; moved = Math.max(moved, Math.abs(d)); x = startPos + d; });
  function end() { dragging = false; car.classList.remove('grabbing'); }
  car.addEventListener('pointerup', end); car.addEventListener('pointercancel', end);
  car.addEventListener('pointerleave', function () { if (dragging) end(); });
  car.addEventListener('dragstart', function (e) { e.preventDefault(); });
  car.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
})();
